import type { IUseCase } from '@/shared/contracts/use-case.contract';
import type { IHttpClient } from '@/shared/contracts/http-client.contract';
import { HttpMethod } from '@/shared/contracts/http-client.contract';
import { UIError } from '@/shared/utils/ui-error';

import { ENDPOINT, type Response } from '../types/order-status-history';

type UseCaseInput = {
  order_id: string;
};

type UseCaseOutput = Response;

export class GetOrderStatusHistoryUseCase implements IUseCase<UseCaseInput, UseCaseOutput> {
  private client: IHttpClient;

  constructor(client: IHttpClient) {
    this.client = client;
  }

  async execute(input: UseCaseInput): Promise<UseCaseOutput> {
    const { order_id } = input;

    console.log('[GetOrderStatusHistoryUseCase] Execute chamado com:', { order_id });

    if (!order_id) {
      console.error('[GetOrderStatusHistoryUseCase] order_id não fornecido');
      throw new UIError('ORDER_NOT_FOUND', 'Pedido não encontrado.');
    }

    const endpoint = `${ENDPOINT}/${order_id}/status-history`;
    console.log('[GetOrderStatusHistoryUseCase] Fazendo requisição para:', endpoint);

    try {
      const result = await this.client.sendRequest<UseCaseOutput, UseCaseInput>({
        endpoint,
        method: HttpMethod.GET,
      });
      console.log('[GetOrderStatusHistoryUseCase] Resposta recebida:', result);
      return result;
    } catch (error) {
      console.error('[GetOrderStatusHistoryUseCase] Erro na requisição:', error);
      throw error;
    }
  }
}
